import { render } from "./AIFloatReport.vue?vue&type=template&id=1742f9d6&scoped=true"
import script from "./AIFloatReport.vue?vue&type=script&lang=js"
export * from "./AIFloatReport.vue?vue&type=script&lang=js"

import "./AIFloatReport.vue?vue&type=style&index=0&id=1742f9d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1742f9d6"]])

export default __exports__